"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FundsRepository {
    fetcherAmplify;
    constructor(fetcherAmplify) {
        this.fetcherAmplify = fetcherAmplify;
    }
    async getFunds() {
        return this.fetcherAmplify.get(`/v1/funds`);
    }
    async findFund(fundId = 'globalGrowth') {
        return this.fetcherAmplify.get(`/v1/funds/${fundId}`);
    }
    async getFundComposition(fundId) {
        return this.fetcherAmplify.get(`/v1/funds/${fundId}/compositions`);
    }
    async getHistorySharePrice(fundId, series) {
        return this.fetcherAmplify.get(`/v1/funds/${fundId}/history`, {
            queryStringParameters: {
                series,
            },
        });
    }
    async getReturn(params) {
        return this.fetcherAmplify.get(`/v1/funds/${params.fundId}/return`, {
            queryStringParameters: {
                series: params.series,
                startDate: params.startDate,
                endDate: params?.endDate,
            },
        });
    }
    async getPivoltFundHistory(fundId, date) {
        return this.fetcherAmplify.get(`/v1/funds/${fundId}/portfolio`, {
            queryStringParameters: {
                ...(date && { date }),
            },
        });
    }
}
exports.default = FundsRepository;
//# sourceMappingURL=FundsRepositoryImpl.js.map